import { useSetting } from './useSetting';
import * as ViewModel from '@/core/presenter/viewModel/viewTypes';
import SettingViewHeader from './components/SettingViewHeader';
import MainView from './components/MainView';
import PwdSettingView from './components/PwdSettingView';
import CheckPwdSettingView from './components/CheckPwdSettingView';
import ExitView from './components/ExitView';
import FooterBar from '@/components/navbar/FooterBar';
import PinSettingView from './components/PinSettingView';
import { observer } from 'mobx-react-lite';
import ManageWalletBalanceView from './components/ManageWalletBalanceView';

const Setting = observer(() => {
  const {
    isOpen,
    prePassword,
    settingViewType,
    isPrePasswordCheckedBtn,
    newPassword,
    confirmPassword,
    isNewPasswordValid,
    isNotMatchPassword,
    isCheckPasswordDisabled,
    isChecked,
    lastLoginTime,
    pin,
    isPinCheckFailed,
    pinStep,
    isNotMatchPin,
    isConfirmPasswordValid,
    userStatus,
    adminWalletInfo,
    isLogoutModalOpen,
    exitViewType,
    isPwdCheckFailedModalOpen,
    isPinChangeSuccessModalOpen,
    isPwdChangeSuccessModalOpen,
    isPwdChangeFailedModalOpen,
    onClickPwdChangeFailedModalConfirm,
    isWithdrawConfirmModalOpen,
    isWithdrawCompleteModalOpen,
    onClickNumberBtn,
    OnClickDeleteBtn,
    onClickAllClearBtn,
    onClickPinChangeSuccessModalConfirm,
    onChangeSettingViewType,
    onClickToggleBtn,
    onClickLogoutBtn,
    onClickLogoutModalClose,
    onClickLogoutModalConfirm,
    onChangePassword,
    onClickPwdNextBtn,
    onClickPwdCheckFailedModalClose,
    onChangeNewPassword,
    onChangeConfirmPassword,
    onBlurNewPassword,
    onKeyDownCheckNewPassword,
    onClickCompleteBtn,
    onClickPwdChangeSuccessModalConfirm,
    onClickCheckbox,
    onClickWithdrawBtn,
    onClickWithdrawConfirmModalClose,
    onClickWithdrawConfirmModalYes,
    onClickWithdrawCompleteModalConfirm,
    onMoveSettingMainView,
    onClickAddHomeBtn,
    onBlurPassword,
    onClickRefreshAdminWalletBtn,
    onChangeExitViewType,
  } = useSetting();

  return (
    <div className={settingViewType !== ViewModel.SettingViewType.PIN_SETTING ? 'main-container sub-container' : 'page-container'}>
      {/* <div className="main-container sub-container"> */}
      {settingViewType === ViewModel.SettingViewType.MAIN && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="설정"
          />
          <MainView
            lastLoginTime={lastLoginTime ?? ''}
            isOpen={isOpen}
            userStatus={userStatus || 0}
            isLogoutModalOpen={isLogoutModalOpen}
            onClickToggleBtn={onClickToggleBtn}
            onClickLogoutBtn={onClickLogoutBtn}
            onClickLogoutModalClose={onClickLogoutModalClose}
            onClickLogoutModalConfirm={onClickLogoutModalConfirm}
            onChangeSettingViewType={onChangeSettingViewType}
            onClickAddHomeBtn={onClickAddHomeBtn}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.PWD_SETTING && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="비밀번호 재설정"
          />
          <PwdSettingView
            isPrePasswordCheckedBtn={isPrePasswordCheckedBtn}
            prePassword={prePassword}
            isPwdCheckFailedModalOpen={isPwdCheckFailedModalOpen}
            onChangePassword={onChangePassword}
            onClickPwdNextBtn={onClickPwdNextBtn}
            onClickPwdCheckFailedModalClose={onClickPwdCheckFailedModalClose}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.CHECK_PWD_SETTING && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="비밀번호 재설정"
          />
          <CheckPwdSettingView
            newPassword={newPassword}
            confirmPassword={confirmPassword}
            isNewPasswordValid={isNewPasswordValid}
            isNotMatchPassword={isNotMatchPassword}
            isCheckPasswordDisabled={isCheckPasswordDisabled}
            isConfirmPasswordValid={isConfirmPasswordValid}
            isPwdChangeSuccessModalOpen={isPwdChangeSuccessModalOpen}
            isPwdChangeFailedModalOpen={isPwdChangeFailedModalOpen}
            onClickPwdChangeFailedModalConfirm={onClickPwdChangeFailedModalConfirm}
            onChangeNewPassword={onChangeNewPassword}
            onChangeConfirmPassword={onChangeConfirmPassword}
            onBlurNewPassword={onBlurNewPassword}
            onKeyDownCheckNewPassword={onKeyDownCheckNewPassword}
            onClickCompleteBtn={onClickCompleteBtn}
            onClickPwdChangeSuccessModalConfirm={onClickPwdChangeSuccessModalConfirm}
            onBlurPassword={onBlurPassword}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.PIN_SETTING && (
        <>
          <PinSettingView
            pin={pin}
            isPinCheckFailed={isPinCheckFailed}
            pinStep={pinStep}
            isNotMatchPin={isNotMatchPin}
            isPinChangeSuccessModalOpen={isPinChangeSuccessModalOpen}
            onClickNumberBtn={onClickNumberBtn}
            OnClickDeleteBtn={OnClickDeleteBtn}
            onClickAllClearBtn={onClickAllClearBtn}
            onClickPinChangeSuccessModalConfirm={onClickPinChangeSuccessModalConfirm}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.EXIT && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="계정 및 보안"
            exitViewType={exitViewType}
            onChangeExitViewType={onChangeExitViewType}
          />
          <ExitView
            isChecked={isChecked}
            onClickCheckbox={onClickCheckbox}
            onClickWithdrawBtn={onClickWithdrawBtn}
            exitViewType={exitViewType}
            onChangeExitViewType={onChangeExitViewType}
            isWithdrawConfirmModalOpen={isWithdrawConfirmModalOpen}
            isWithdrawCompleteModalOpen={isWithdrawCompleteModalOpen}
            onClickWithdrawConfirmModalClose={onClickWithdrawConfirmModalClose}
            onClickWithdrawConfirmModalYes={onClickWithdrawConfirmModalYes}
            onClickWithdrawCompleteModalConfirm={onClickWithdrawCompleteModalConfirm}
          />
        </>
      )}
      {settingViewType === ViewModel.SettingViewType.MANAGE_WALLET_BALANCE && (
        <>
          <SettingViewHeader
            settingViewType={settingViewType}
            onChangeSettingViewType={onChangeSettingViewType}
            title="관리지갑 잔액 확인"
          />
          <ManageWalletBalanceView
            adminWalletInfo={adminWalletInfo}
            onClickRefreshAdminWalletBtn={onClickRefreshAdminWalletBtn}
          />
        </>
      )}
      <FooterBar settingViewType={settingViewType} onMoveSettingMainView={onMoveSettingMainView} />
    </div>
  );
});

export default Setting;
